export default [
  {
    title: 'Campaigns',
    component: 'discounts',
    section: 'store',
    order: 1,
    icon: 'whatshot'
  }
]
